import { tns } from 'tiny-slider/src/tiny-slider';
import smoothscroll from "smoothscroll-polyfill";
import Swiper from "swiper/bundle";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/bundle";


const quoteSliders = document.querySelectorAll('.block-quote-slider .slides');
const blockGallerySliders = document.querySelectorAll('.acf-gallery .swiper');
const counterSliders = document.querySelectorAll('.block-counter .slides');

function initSliders() {
	if (blockGallerySliders && blockGallerySliders.length > 0) {
		blockGallerySliders.forEach((sliderEl) => {
			new Swiper(sliderEl, {
				modules: [Navigation, Pagination],
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: sliderEl.querySelector('.swiper-pagination'),
					type: 'bullets',
					clickable: true,
				},
				mousewheel: { forceToAxis: true },
				keyboard: true,
				spaceBetween: 12,
				slidesPerView: 1,
				centeredSlides: true,
				breakpoints: {
					768: {
						slidesPerView: 'auto',
						centeredSlides: false,
						spaceBetween: 24,
					},
				},
				on: {
					reachEnd: function (swiper) {
						swiper.snapGrid = [...swiper.slidesGrid];
					},
				}
			});
		});
		const figures = document.querySelectorAll('.figure');
		const resizeFigcaption = () => {
			figures.forEach((figure) => {
				const img = figure.querySelector('img');
				const figcaption = figure.querySelector('figcaption'); console.log(figcaption);
				if (figcaption) {
					figcaption.style.width = img.clientWidth + 'px';
				}
			});
		};
		resizeFigcaption();
		window.addEventListener('resize', function () {
			resizeFigcaption();
		});

	}

	if (quoteSliders && quoteSliders.length > 0) {
		(smoothscroll) ? smoothscroll.polyfill() : null;
		quoteSliders.forEach((sliderEl) => {
			let controls = sliderEl.parentElement.parentElement.parentElement.parentElement.querySelector('.custom-controls');
			let slides = sliderEl.querySelectorAll('.slide');
			new Swiper(sliderEl.parentElement, {
				modules: [Navigation, Pagination],
				mouseDrag: true,
				swipeAngle: false,
				mousewheel: { forceToAxis: true },
				keyboard: true,
				navigation: {
					nextEl: controls.querySelector('.next'),
					prevEl: controls.querySelector('.prev')
				},
				on: {
					slideChange: (swiper) => {
						const actualSlide = slides[swiper.activeIndex];
						if (actualSlide.querySelector('.read-more')) {
							actualSlide.querySelector('.read-more').style.display = 'block';
							actualSlide.querySelector('.text-expand').style.display = 'none';
							window.scroll({
								behavior: 'smooth',
								top: (sliderEl.getBoundingClientRect().top - 100 - document.body.getBoundingClientRect().top - document.querySelector('#header').clientHeight)
							});
						}
					}
				}
			});
		});
		let readMoreButtons = document.querySelectorAll('.read-more');
		if (readMoreButtons && readMoreButtons.length > 0) {
			readMoreButtons.forEach(btn => {
				btn.addEventListener('click', () => {
					btn.parentElement.querySelector('.text-expand').style.display = 'inline';
					btn.style.display = 'none';
				});
			});
		}
	}

	if (counterSliders && counterSliders.length > 0) {
		counterSliders.forEach((sliderEl) => {
			tns({
				container: sliderEl,
				controls: true,
				navPosition: 'bottom',
				mouseDrag: true,
				lazyload: true,
				items: 1,
				slideBy: 1,
				responsive: {
					420: {
						items: 3,
						controls: false,
						autoHeight: false,
					}
				}
			});
		});
	}
}

export default () => {
	initSliders();
};
